export default function CsvAttractionPreview() {
  const REQUIRED_HEADERS = [
    'Nome ITA', 'Nome ENG', 'Descrizione ITA', 'Descrizione ENG',
    'Categorie', 'Longitudine', 'Latitudine', 'Attività', 'Stagione', 'Attrazioni'
  ];

  const fileInput = document.querySelector('#attractions_csv_input');
  const previewContainer = document.querySelector('#preview');
  console.log('CsvAttractionPreview initialized');
  console.log(fileInput);
  console.log(previewContainer);
  
  if (fileInput && previewContainer) {
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      
      if (!file) {
        previewContainer.innerHTML = '';
        return;
      }

      if (!file.name.endsWith('.csv')) {
        alert('Please upload a CSV file');
        fileInput.value = '';
        previewContainer.innerHTML = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target.result;
        const rows = content.split('\n')
          .map(row => row.split(';')) // Changed to only use semicolon
          .filter(row => row.length > 1);

        if (rows.length === 0) {
          alert('CSV file is empty');
          fileInput.value = '';
          previewContainer.innerHTML = '';
          return;
        }

        const headers = rows[0].map(header => header.trim());

        // Validate headers
        const missingHeaders = REQUIRED_HEADERS.filter(
          requiredHeader => !headers.includes(requiredHeader)
        );

        if (missingHeaders.length > 0) {
          alert(`Missing required headers: ${missingHeaders.join(', ')}`);
          fileInput.value = '';
          previewContainer.innerHTML = '';
          return;
        }

        // Remove headers after validation
        rows.shift();
        
        let previewHtml = `
          <div class="alert alert--info">
            <h4><strong>${rows.length}</strong> attractions will be imported</h4>
            <div class="preview-list">
            <table class="table---bordered">
            <tbody>
        `;

        rows.slice(0, 20).forEach(row => {
          const name = row[0].replace(/"/g, '');
          previewHtml += `
              <tr>
                <td>${name}</td>
                <td>${row[5]}</td>
                <td>${row[6]}</td>
                <td>${row[8]}</td>
                <td>${row[9]}</td>
              </tr>
          `;
        });


        if (rows.length > 20) {
          previewHtml += '<tr><td>...</td><td>...</td><td>...</td><td>...</td><td>...</td></tr>';
        }

        previewHtml += `
            </tbody>
            </table>
        `;

        previewHtml += '</div></div>';
        previewContainer.innerHTML = previewHtml;
      };

      reader.readAsText(file);
    });
  }
}